<template>
    <div class="main-div">
        <img :src="dialogRef.data.imageUrl" alt="snapshot" class="w-full rounded" />
        <XMarkIcon class="close-icon" @click="closeDialog" />
    </div>
</template>

<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
import { ModalNames } from '~/types/modals';

const dialogRef =   getDialogRef(ModalNames.IMAGE_VIEWER);

const closeDialog = () => {
    dialogRef.value.close();
};
</script>

<style lang="scss" scoped>
.main-div {
    @apply scale-90 bg-white w-full lg:w-[600px] h-full lg:h-[400px] rounded relative;

    .close-icon {
        @apply absolute top-4 right-4 text-gray-900 w-5 h-5 cursor-pointer;
    }
}
</style>
